import { render, staticRenderFns } from "./PinnedMsgs.vue?vue&type=template&id=065349ba&scoped=true&"
import script from "./PinnedMsgs.vue?vue&type=script&lang=js&"
export * from "./PinnedMsgs.vue?vue&type=script&lang=js&"
import style0 from "./PinnedMsgs.vue?vue&type=style&index=0&id=065349ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "065349ba",
  null
  
)

export default component.exports